<!-- 嵌入式-配件入库管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 配件入库
      </el-button>
      <div class="former">
        <select2
          labelName="NameNumber"
          v-model="former.DciAccessoryModelID"
          url="dci/model/accessory/list?order=name"
          clearable
          placeholder="请选择配件型号"
          no-data-text="没有配件型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.Status"
          url="dci/accessory/stock-status-list"
          clearable
          placeholder="请选择状态"
          no-data-text="没有状态"
        ></select2>&nbsp;
        <el-input
          v-model.trim="former['SN:like']"
          placeholder="输入SN"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="DciAccessoryModel.Name" label="配件型号名称" />
      <el-table-column prop="DciAccessoryModel.Number" label="配件型号" />
      <el-table-column prop="SN" label="配件SN" >
         <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="DciProduct.SN" label="关联产品SN" >
         <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="入库日期" align="center" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.StockinAt">
            {{ scope.row.StockinAt.substring(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" width="80" >
        <template slot-scope="{ row }">
          <el-tag v-if="row.Status === 1" type="warning">
            {{ row.StatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
    <create v-model="item"
      :visible.sync="createVisible"
      @form:saved="getItemList" />
    <edit v-model="item"
      :visible.sync="editVisible"
      @form:saved="getItemList" />
  </el-card>
</template>

<script>
import Create from './create.vue';
import Edit from './edit.vue';

export default {
  components: {
    Create,
    Edit,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        DciAccessoryModelID: '',
        Status: '',
        'SN:like': '',
      },
      item: this.getEmptyItem(),
      createVisible: false,
      editVisible: false,
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get('dci/accessory/stock-in-list', {
          params: {
            where: this.former,
            ...this.pager,
            with: ['DciAccessoryModel', 'DciProduct'],
            order: ['-stockin_at', '-sn'],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.createVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.editVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm('确定要删除此配件吗？', '提示')
        .then(() => this.$axios.delete(`dci/accessory/stock-in-delete/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success('删除成功');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {};
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
  },
};
</script>
